export default {
    palette: {
        primary: {
            main: '#006ae7'
        }
    },
    typography: {
        fontFamily: '"Open Sans", sans-serif'
    },
    props: {
        MuiModal: { disableScrollLock: true },
        MuiDialog: { disableScrollLock: true },
        MuiDrawer: { disableScrollLock: true },
        MuiMenu: { disableScrollLock: true },
        MuiPopover: { disableScrollLock: true },
    },
    overrides: {
        // Style sheet name ⚛️
        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'none'
                }
            }
        },
        MuiPaper: {
            root: {
                color: 'rgba(68,68,68,0.88)',
                display: 'block'
            }
        },
        MuiButton: {
            contained: {
                boxShadow: 'none',
                borderRadius: '10px',
                lineHeight: '1',
                padding: '12px 16px',
                fontSize: '13px',
                fontWeight: '600',
                height: '36px',
                textTransform: 'uppercase'
            },
            text: {
                color: 'rgba(68, 68, 68, 0.88)',
                fontSize: '13px',
                padding: '8px 16px',
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: '600'
            },
            outlined: {
                boxShadow: 'none',
                borderRadius: '10px',
                lineHeight: '1',
                padding: '12px 16px',
                fontSize: '13px',
                fontWeight: '600',
                height: '36px',
                textTransform: 'uppercase',
                border: 'solid 1px rgba(68, 68, 68, 0.24)',
                color: 'rgba(68, 68, 68, 0.88)'
            }
        },
        MuiTypography: {
            colorPrimary: {
                '&.linkPrimary': {
                    color: '#006ae7'
                },
                '&.linkPrimary:hover': {
                    color: '#006ae7',
                    textDecoration: 'underline'
                }
            }
        },
        MuiInputBase: {
            input: {
                // height: 'auto',
                boxSizing: 'border-box',
                fontSize: '13px',
                borderRadius: '6px',
                '&.Mui-disabled': {
                    color: 'rgba(43, 43, 43, 0.34)!important'
                },
            }
        },
        MuiMenuItem: {
            root: {
                minHeight: 'unset',
                fontSize: '13px',
                padding: '4px 8px',
            }
        },
        MuiOutlinedInput: {

            input: {
                padding: '8px',
                height: '36px',
                color: 'rgba(68, 68, 68, 0.88)',
                // fontWeight: '700',
                '&.MuiSelect-selectMenu': {
                    height: '36px'
                },
            },
            notchedOutline: {
                borderRadius: '6px',
                border: 'solid 1px',
                borderColor: 'rgb(43 43 43 / 34%)',
                "& legend": {
                    fontSize: ".65em"
                }
            },

            root: {
                '&:hover': {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgb(43 43 43 / 54%)'
                    }
                },
                '&.Mui-focused': {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        borderColor: 'rgb(43 43 43 / 54%) !important'
                    }
                },
                MuiSelect: {
                    backgroundColor: 'red',
                    color: 'rgba(68, 68, 68, 0.28)!important'
                },
                '&.Mui-disabled': {
                    color: 'rgba(68, 68, 68, 0.28)!important',
                    pointerEvents: 'none',
                    '& > .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(68, 68, 68, 0.16) !important',
                    }
                },
                error: {
                    borderColor: 'rgb(247, 6, 6)',
                },
            }
        },
        MuiFormControl: {
            marginNormal: {
                marginTop: '4px',
                marginBottom: '8px'
            }
        },
        MuiInputLabel: {
            outlined: {
                transform: 'translate(14px, 12px) scale(1)'
            },
            formControl: {}
        },
        MuiRadio: {
            root: {
                padding: '4px',
                '& .MuiSvgIcon-root': {
                    width: '20px',
                    height: '20px'
                }
            }
        },
        MuiFormLabel: {
            root: {
                color: 'rgba(68, 68, 68, 0.56)',
                fontSize: '13px',
                '&.Mui-disabled': {
                    color: 'rgba(43, 43, 43, 0.54)!important',
                }
            },
            // '&.Mui-disabled': {
            //     color: 'rgba(68, 68, 68, 0.28)!important',
            // }
            // '&.Mui-focused': {
            //     color: 'rgba(68, 68, 68, 0.56)'
            // }
        },
        MuiFormControlLabel: {
            label: {
                '&.Mui-disabled': {
                    color: 'rgba(68, 68, 68, 0.28)!important'
                }
            }
        },
        MuiDialog: {
            paperWidthSm: {
                width: '100%',
                maxWidth: '712px',
                borderRadius: '6px',
                boxShadow: '0 4px 16px 0 rgba(52, 52, 52, 0.24)',
                padding: '32px'
            }
        },
        MuiPopover: {
            paper: {
                '&::-webkit-scrollbar': {
                    width: '6px',
                    height: '5px'
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(68, 68, 68, 0.16)',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '3.5px',
                    boxShadow: 'none'
                },
                '&::-webkit-scrollbar-track': {
                    background: 'none'
                },
                '&::-webkit-scrollbar-button': {
                    backgroundImage: 'none',
                    backgroundRepeat: 'no-repeat',
                    width: '0',
                    height: '0'
                }
            }
        }
    }
}
